<template>
    <DefaultModal :class="'language_modal'" :is-show="isShow" @update:is-show="emit('update:isShow', $event)">
        <template #title>{{ $t('pages.student.home.languageSetting.title') }}</template>
        <template #message>
            <p>{{ $t('pages.student.home.languageSetting.description') }}</p>
            <div class="language_list">
                <button
                    v-for="lang in SUPPORTED_LOCALES"
                    :key="lang.code"
                    :class="selectedLocale === lang.code ? 'is_selected' : ''"
                    @click="selectedLocale = lang.code"
                >
                    <i class="flag_icon" :class="lang.code" />
                    <span>{{ lang.label }}</span>
                </button>
            </div>
        </template>
        <template #btns>
            <button class="btn_cancel" type="button" @click="close"
                ><span>{{ $t('buttons.cancel') }}</span></button
            >
            <button class="btn_save" type="button" color="primary" @click="handleSave"
                ><span>{{ $t('buttons.save') }}</span></button
            >
        </template>
    </DefaultModal>
</template>

<script setup lang="ts">
    import { ref, watch } from 'vue';
    import { SUPPORTED_LOCALES } from '@/app/lang/locales';
    import { useSystemStoreWithOut } from '@/app/stores/system';
    import DefaultModal from '@/app/components/modals/DefaultModal.vue';

    const props = defineProps<{
        isShow: boolean;
    }>();

    const emit = defineEmits(['update:isShow']);

    const systemStore = useSystemStoreWithOut();
    const selectedLocale = ref(systemStore.locale);

    watch(
        () => props.isShow,
        (show) => {
            if (show) {
                selectedLocale.value = systemStore.locale;
            }
        },
    );

    function close() {
        emit('update:isShow', false);
    }

    function handleSave() {
        systemStore.changeLocale(selectedLocale.value);
        close();
    }
</script>
